

















import { Component, Vue } from 'vue-property-decorator'
import requests, { Response } from '@/helpers/requests'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import { OnSubmitEvent } from '@/components/ui/types'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface RequestPayload {
    pulsemAccountId: number;
    productCode: string;
}


interface Product {
    name: string;
    productCode: string;
}


/**
 * This represents the response payload from the backend.
 * @property subscribedProducts: Represents the products that a location currently has.
 * @property availableProducts: Represents the products that can be purchased for a location.
 */
interface PageData {
    stripeCustomerId: string;
    warningMessage: string|null;
    subscribedProducts: Product[];
    availableProducts: Product[];
}


interface LoadResponse extends Response {
    data: PageData;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class RemoveProduct extends Vue {
    stripeCustomerIdHint = `
    Please validate that this is the correct Stripe Customer ID, if not, please contact the tech team.
    This field is not editable.
    `
    locationValid = false
    isLoading = false
    addingProductSupported = true
    loadInformationErrorMessage: string|null = null

    // Request payload to backend
    pulsemAccountId: number|null = null
    productCode: string|null = null

    // Load payload from backend
    pageData: PageData|null = null

    subscribedProductHeaders = [
        { text: 'Product Name', align: 'left', value: 'name' }
    ]

    async onSubmit(event: OnSubmitEvent<LoadResponse>) {
        if (event.success && event.response) {
            this.productCode = null
            this.pageData = event.response.data
        }
    }

    async onLocationChange(locationValid: boolean) {
        this.loadInformationErrorMessage = null
        this.pageData = null
        this.addingProductSupported = true
        if (locationValid) {
            this.isLoading = true
            try {
                const response = await requests.post('/support/products/load-products', {
                    pulsemAccountId: this.pulsemAccountId
                }) as LoadResponse
                this.pageData = response.data
                if (this.warningMessage) {
                    this.loadInformationErrorMessage = this.warningMessage
                    this.addingProductSupported = false
                }
                this.locationValid = locationValid
            } catch(e) {
                this.loadInformationErrorMessage = e.message
                this.locationValid = false
            }
            this.isLoading = false
        } else {
            this.locationValid = false
            this.isLoading = false
        }
    }

    get requestPayload(): RequestPayload|null {
        if (!this.pulsemAccountId || !this.productCode) {
            return null
        } else {
            return {
                pulsemAccountId: this.pulsemAccountId,
                productCode: this.productCode
            }
        }
    }

    get inputsDisabled(): boolean {
        return !this.pageData || !this.addingProductSupported
    }

    get stripeCustomerId(): string|null {
        return this.pageData?.stripeCustomerId || null
    }

    get warningMessage(): string|null {
        return this.pageData?.warningMessage || null
    }

    get subscribedProducts(): Product[] {
        return this.pageData?.subscribedProducts || []
    }
}
